import { Component, ChangeDetectionStrategy, Output, EventEmitter, HostListener, ChangeDetectorRef, ViewRef, Input } from '@angular/core';
import { Column } from '../../models/column';
import { DataFormat } from '../../models/dataformat';
import { HelperService } from '../../Services/Helper.Service';

@Component({
  selector: 'mdg-formatter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // templateUrl: 'MDG.Formatter.html',
  template: `<div *ngIf="showFormatter" class='mdg-filter-container'>
    <div class="mdg-formatter-popup-container">
      <div class='row'>
        <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
          <div class='row'>
            <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
              <h3 class="no-margin">Field : {{data.fieldValue}} | <small>{{selectedColumn.displayName}}</small></h3>
            </div>
          </div>
          <hr class="buffer-5-0">
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
          <div class="row padding-10">
            <div class="col-md-2 col-sm-4 col-xs-12 no-padding">
              <label class="padding-5">Display Text </label>
            </div>
            <div class="col-md-10 col-sm-8 col-xs-12 no-padding">
              <input class="form-control no-radius" placeholder="Display Text" maxlength="150" [(ngModel)]='data.displayName'>
            </div>
          </div>
          <hr class="buffer-5-0">
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6">
          <div class='row'>
            <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
              <h4 class="no-margin">Header Style</h4>
            </div>
          </div>
          <hr class="buffer-5-0">
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Text Align</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Header Align" [(ngModel)]='data.header.textAlign'>
                <option disabled='disabled' selected> Select Align</option>
                <option value="left">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Size</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <input class="form-control no-radius" placeholder="Font Size" [(ngModel)]='data.header.fontSize' type="number">
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Weight</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Font Weight" [(ngModel)]='data.header.fontWeight'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="normal">Normal</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="300">300</option>
                <option value="400">400</option>
                <option value="500">500</option>
                <option value="600">600</option>
                <option value="700">700</option>
                <option value="800">800</option>
                <option value="900">900</option>
                <option value="bold">Bold</option>
                <option value="bolder">Bolder</option>
                <option value="lighter">Lighter</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Style</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Font Style" [(ngModel)]='data.header.fontStyle'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="normal">Normal</option>
                <option value="italic">Italic</option>
                <option value="oblique">Oblique</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Text Orientation</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Text Orientation" [(ngModel)]='data.header.textOrientation'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="unset">Unset</option>
                <option value="mixed">Mixed</option>
                <option value="sideways">Sideways</option>
                <option value="sideways-right">Sideways Right</option>
                <option value="upright">Up Right</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6">
          <div class='row'>
            <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
              <h4 class="no-margin">Cell Style</h4>
            </div>
          </div>
          <hr class="buffer-5-0">
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Text Align</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Header Align" [(ngModel)]='data.cell.textAlign'>
                <option disabled='disabled' selected> Select Align</option>
                <option value="left">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Size</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <input class="form-control no-radius" placeholder="Font Size" [(ngModel)]='data.cell.fontSize' type="number">
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Weight</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Font Weight" [(ngModel)]='data.cell.fontWeight'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="normal">Normal</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="300">300</option>
                <option value="400">400</option>
                <option value="500">500</option>
                <option value="600">600</option>
                <option value="700">700</option>
                <option value="800">800</option>
                <option value="900">900</option>
                <option value="bold">Bold</option>
                <option value="bolder">Bolder</option>
                <option value="lighter">Lighter</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Font Style</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Font Style" [(ngModel)]='data.cell.fontStyle'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="normal">Normal</option>
                <option value="italic">Italic</option>
                <option value="oblique">Oblique</option>
              </select>
            </div>
          </div>
          <div class="row padding-10">
            <div class="col-md-4 col-sm-5 col-xs-12 no-padding">
              <label class="padding-5">Text Orientation</label>
            </div>
            <div class="col-md-8 col-sm-7 col-xs-12 no-padding">
              <select class="form-control no-radius" placeholder="Text Orientation" [(ngModel)]='data.cell.textOrientation'>
                <option disabled='disabled' selected> Select Option</option>
                <option value="unset">Unset</option>
                <option value="mixed">Mixed</option>
                <option value="sideways">Sideways</option>
                <option value="sideways-right">Sideways Right</option>
                <option value="upright">Up Right</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
          <hr class="buffer-5-0">
          <div class='row'>
            <div class="col-xs-12 text-lg-right text-md-right text-sm-right">
              <button class='btn btn-sm btn-primary right-buffer-10' (click)='saveFormat()'>Apply</button>
              <button class='btn btn-sm btn-default' (click)='cancelFormat()'>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  `
})
export class MDGFormatterComponent {
  selectedColumn: Column;
  selectedColumnB: Column;
  flatColKey: any;
  @Input() formattedFields: any = {};
  @Output() updateFormat: EventEmitter<DataFormat> = new EventEmitter<DataFormat>();

  data: DataFormat;
  showFormatter: boolean = false;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showFormatter) {
      this.showFormatter = false;
    }
  }

  constructor(private cdRef: ChangeDetectorRef, private helper: HelperService) {
    this.selectedColumn = new Column();
    this.selectedColumnB = new Column();
    this.selectedColumn.header = this.helper.getHeaderStyle();
    this.selectedColumn.cell = this.helper.getCellStyle();
    this.selectedColumnB.header = this.helper.getHeaderStyle();
    this.selectedColumnB.cell = this.helper.getCellStyle();
    this.data = new DataFormat();
    this.data.header = this.helper.getHeaderStyle();
    this.data.cell = this.helper.getCellStyle();
  }

  ShowFormat(selColumn: Column, colKey: any) {
    this.flatColKey = colKey instanceof Array ? colKey.join(String.fromCharCode(0)) : colKey;
    this.selectedColumn = selColumn;
    if (this.formattedFields[this.flatColKey]) {
      this.data = this.helper.copyObject(this.formattedFields[this.flatColKey]);
      this.data.colName = selColumn.colName;
      if (this.data.displayName === undefined || this.data.displayName === null || this.data.displayName === '') {
        this.data.displayName = colKey;
      }
    } else {
      this.data = new DataFormat();
      this.data.colName = selColumn.colName;
      this.data.fieldValue = colKey instanceof Array ? colKey.join(',') : colKey;
      this.data.displayName = this.data.fieldValue;
      this.data.flatKeyValue = this.flatColKey;
      this.data.currencySymbol = selColumn.currencySymbol;
      this.data.dataType = selColumn.dataType;
      this.data.dateFormat = selColumn.dateFormat;
      this.data.decimalPlaces = selColumn.decimalPlaces;
      this.data.header = this.helper.copyObject(selColumn.header);
      this.data.cell = this.helper.copyObject(selColumn.cell);
      this.data.thousandSepartor = selColumn.thousandSepartor;
    }
    if (!this.data.cell) {
      this.data.cell = this.helper.getCellStyle();
    }
    if (!this.data.header) {
      this.data.header = this.helper.getHeaderStyle();
    }
    this.detectChanges();
    setTimeout(() => {
      this.showFormatter = true;
      this.detectChanges();
    }, 10);
  }

  saveFormat() {
    this.showFormatter = false;
    this.formattedFields[this.flatColKey] = this.data;
    setTimeout(() => {
      this.updateFormat.emit(this.data);
    }, 10);
  }

  cancelFormat() {
    this.showFormatter = false;
    this.selectedColumn = this.helper.copyObject(this.selectedColumnB);
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }
}
